// src/js/utils/pulse.js

// -------------------------------------------------------------
// GoTop híbrido perfecto (Jubesa)
// -------------------------------------------------------------
// ✔ Robusto
// ✔ Suave
// ✔ Sin flickers
// ✔ Sin resets peligrosos
// ✔ Funciona en móvil real y simulado
// ✔ No depende de media queries
// -------------------------------------------------------------

document.addEventListener('DOMContentLoaded', () => {
  const goTop = document.querySelector('.jubesa__GoTop');
  if (!goTop) return;

  let pulsing = false;
  let hasAppeared = false;

  const SHOW_THRESHOLD = 120;
  const HIDE_THRESHOLD = 40;

  // -------------------------------------------------------------
  // RESET VISUAL SEGURO
  // -------------------------------------------------------------
  const safeReset = () => {
    goTop.classList.remove('appearing', 'pulsing', 'fading');

    goTop.style.transition = 'none';
    goTop.style.animation = 'none';
    goTop.style.opacity = '0';
    goTop.style.visibility = 'hidden';
    goTop.style.pointerEvents = 'none';
    goTop.style.transform = 'translateY(0) scale(1)';

    void goTop.offsetWidth;

    goTop.style.transition = '';
    goTop.style.animation = '';

    pulsing = false;
    hasAppeared = false;
  };

  // -------------------------------------------------------------
  // Listener de animación
  // -------------------------------------------------------------
  goTop.addEventListener('animationend', (e) => {
    if (e.animationName === 'jubesaFadeOut') {
      safeReset();
    }
  });

  // -------------------------------------------------------------
  // Listener de scroll
  // -------------------------------------------------------------
  window.addEventListener('scroll', () => {
    const y = window.scrollY;

    // Mostrar
    if (y > SHOW_THRESHOLD) {
      if (!hasAppeared) {
        goTop.classList.remove('fading');
        goTop.classList.add('appearing');

        setTimeout(() => {
          goTop.classList.remove('appearing');
          goTop.classList.add('pulsing');
        }, 350);

        hasAppeared = true;
        pulsing = true;
        return;
      }

      if (!pulsing) {
        goTop.classList.remove('fading');
        goTop.classList.add('pulsing');
        pulsing = true;
      }

      return;
    }

    // Ocultar
    if (y < HIDE_THRESHOLD && pulsing) {
      goTop.classList.remove('pulsing');
      goTop.classList.add('fading');

      pulsing = false;
      hasAppeared = false;
    }
  });

  // -------------------------------------------------------------
  // Click → Scroll suave
  // -------------------------------------------------------------
  goTop.addEventListener('click', (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
});
